import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE, ROLE_READ_ONLY } = ROLES;

const ALLOWED_ROLES_VIEW_SETTLEMENTS = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE, ROLE_READ_ONLY];

const ALLOWED_ROLES_CREATE_SETTLEMENT = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE];

export function canViewSettlements(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_VIEW_SETTLEMENTS);
}

export function canCreateSettlement(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_CREATE_SETTLEMENT);
}
